import { type IAuthForm } from 'containers/Auth/SignIn/component'
import type React from 'react'
import { createContext, useContext } from 'react'
import { useProvideAuth, type UseProvideAuthType } from 'utils'

interface IAuthProvider {
  children: React.ReactNode
}

const authContext = createContext<UseProvideAuthType>({
  isLoading: false,
  checkingUser: false,
  userEmail: '',
  authToken: '',
  settings: [],
  account: {},
  handleLogin: async function (_data: IAuthForm): Promise<boolean> {
    throw new Error('Function not implemented.')
  },
  handleLogOut: async function (): Promise<void> {
    throw new Error('Function not implemented.')
  },
  rememberMe: false,
  handleRememberMe: function (_rememberMe: boolean): void {
    throw new Error('Function not implemented.')
  },
  getUser: async function (_accountId: string, _email: string): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getUserAsAdmin: async function (_email: string): Promise<any> {
    throw new Error('Function not implemented.')
  },
  updateEmail: async function (
    _email: string,
    _newEmail: string,
    _accountId: string
  ): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getCampaigns: async function (): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getCampaignById: async function (_id: string): Promise<any> {
    throw new Error('Function not implemented.')
  },
  createCampaign: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  editCampaign: async function (_campaignId, _params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  sendCampaign: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  deleteCampaign: async function (_campaignId): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getCampaignLogsById: async function (
    _campaignId: string,
    _startDate: string,
    _endDate: string
  ): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getSettings: async function (_accessToken: string): Promise<any> {
    throw new Error('Function not implemented.')
  },
  uploadAssets: async function (_formData: FormData): Promise<any> {
    throw new Error('Function not implemented.')
  },
  deleteAssets: async function (_key: string): Promise<any> {
    throw new Error('Function not implemented.')
  },
  listAssets: async function (): Promise<any> {
    throw new Error('Function not implemented.')
  },
  renameAssets: async function (
    _oldName: string,
    _newName: string
  ): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getICStatus: async function (_email: string): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getICAccounts: async function (_email: string): Promise<any> {
    throw new Error('Function not implemented.')
  },
  registerICAccount: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  unregisterICAccount: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  changePasswordICAccount: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  linkICAccounts: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  unlinkICAccounts: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getCCSAccount: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  manualConfirmUser: async function (): Promise<any> {
    throw new Error('Function not implemented.')
  },
  updateMailingAddress: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  updateInfo: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  unregisterAccount: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  linkAccount: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  getAllLinkedAccounts: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  },
  updateCognitoAttribute: async function (_params: any): Promise<any> {
    throw new Error('Function not implemented.')
  }
})

export const AuthProvider: React.FC<IAuthProvider> = ({ children }) => {
  const auth = useProvideAuth()

  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

export const useAuth = (): UseProvideAuthType => useContext(authContext)
